<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: hidden; width: 100%;">

    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; overflow: hidden; width: 100%;">
      <mat-toolbar color="primary" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;" class="toolbar-over-card">
        <!-- Title -->
        <div>{{uploadBatchTitle}} | Total Items: <span>{{totalEntries$ | async }}</span></div>

        <div style="display: flex; font-size: medium; gap: 10px;">
          <button mat-menu-item (click)="openReportDialog()" [disabled]="!previousReport" id="open-dat-report" style="color: white; display: flex; align-items: center; min-width: 200px;">
            <div class="fa-duotone fa-file-lines" style="font-size: 18px; margin-right: 6px;"></div>
            <span>View Last Run Report</span>
          </button>
          <button mat-menu-item (click)="startNewDat(uploadBatchId)" [disabled]="isApplyingMetadata" id="upload-dat" style="color: white; display: flex; align-items: center;">
            <div class="fa-duotone fa-file-import" style="font-size: 18px; margin-right: 6px;"></div>
            <span>Replace Dat File</span>
          </button>
          <button mat-menu-item [routerLink]="['/', 'review', 'browse']" [queryParams]="{UploadBatchId: uploadBatchId}" style="color: white; display: flex; align-items: center; gap: 6px;" >
            <span>Browse Upload</span>
            <div class="fa-duotone fa-arrow-right" style="font-size: 18px; margin-left: 6px;"></div>
          </button>
        </div>
      </mat-toolbar>
      <mat-card class="card-under-toolbar" style="overflow: hidden; display: flex; flex-direction: column; height: 100%;">
        <mat-card-content class="mat-elevation-z2" style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div *ngIf="loading || isApplyingMetadata || error" style="width: 100%; height: 100%; display:flex; flex-direction: row; align-content: center; justify-content: center; flex-wrap: wrap; font-size: large;">
            @if (isApplyingMetadata) { Metadata is being generated or applied, this page will reload after it completes }
            @else if (loading) { Dat mapping metadata is loading }
            @else if (error) { An error occurred when getting or saving dat map metadata. Please try again, re-upload the dat file, or contact Professional Services for support }
          </div>
          <div *ngIf="!isApplyingMetadata && !loading && !error" style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" class="table-width" style="width: 100%;">
              <ng-container matColumnDef="dat-column">
                <th mat-header-cell *matHeaderCellDef style="width: 360px">Dat Column</th>
                <td mat-cell *matCellDef="let element">{{element.datColumn}}</td>
              </ng-container>
              <ng-container matColumnDef="lexbe-field">
                <th mat-header-cell *matHeaderCellDef style="width: 290px">Lexbe Field</th>
                <td mat-cell *matCellDef="let element">
				  <div style="display:flex; align-items: center; min-width: 255px;">
                    <mat-select [ngModel]="lexbeFieldFromDatColumn(element.datColumn)" *ngIf="lexbeFields$ | async as lexbeFields" (selectionChange)="assignLexbeField($event, element)">
                      <mat-option value="-- ignore --">-- ignore --</mat-option>
                      <mat-option *ngFor="let field of lexbeFields" [value]="field.fieldId" [disabled]="field.disabled">
					    @if (field.fieldId === BuiltInFieldId.DocTitle || field.fieldId === BuiltInFieldId.ParentId) {
					      <mat-icon class="field-icon" color="accent">star</mat-icon>
					    } @else if (field.type === FieldType.BuiltInFieldText || field.type === FieldType.TextField) {
					      <mat-icon class="field-icon string-type">text_fields</mat-icon>
					    } @else if (field.type === FieldType.BuiltInFieldDate || field.type === FieldType.DateTime) {
					      <mat-icon class="field-icon date-type">event</mat-icon>
					    } @else if (field.type === FieldType.BuiltInFieldUniqueIdentifier) {
					      <mat-icon class="field-icon special-type">link</mat-icon>
						} @else if (field.type === FieldType.CheckBox) {
						  <mat-icon class="field-icon bool-type">rule</mat-icon>
					    } @else {
					      <mat-icon class="field-icon unknown-type">help_outline</mat-icon>
					    }
                        {{field.displayTitle}}
					  </mat-option>
                  	</mat-select>
                  	<button mat-icon-button color="primary" (click)="addNewField(element)" matTooltip="Add New Field" *ngIf="ucs.inRoles(Role.ManageCustomDocFieldsFeatureSet)">
                      <mat-icon>add</mat-icon>
                    </button>
				  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="sample-data1">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">Sample Data 1</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">{{element.sampleData[0]}}</td>
              </ng-container>
              <ng-container matColumnDef="sample-data2">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">Sample Data 2</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">{{element.sampleData[1]}}</td>
              </ng-container>
              <ng-container matColumnDef="sample-data3">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">Sample Data 3</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">{{element.sampleData[2]}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div class="paging-container">
          </div>
        </mat-card-content>
        <mat-card-actions>
          <div style="width:100%; display:flex; justify-content: flex-end;">
            <button mat-button color="primary" (click)="reset()" [disabled]="isApplyingMetadata || loading || error">Reset To Default</button>
			  <button mat-button color="primary" (click)="apply()" [disabled]="isApplyingMetadata || loading || error">Save</button>
			  <button mat-button color="primary" (click)="applyAndRun()" [disabled]="isApplyingMetadata || loading || error">Save & Apply</button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
